import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from "styled-components";
// components
import { Icon } from "../../icon";
import { Link } from "../../link";
// styles
import { DisabledLink, StyledHomeLinkItem, StyledLinkItem, } from "../breadcrumb.styles";
export const LinkItem = ({ data: { text, url, windowTarget = "_self", onClick }, isFirst, isLast, size, previewId, testId, }) => {
    const theme = useTheme();
    const LinkItemWrapper = isFirst ? StyledHomeLinkItem : StyledLinkItem;
    if (!url || isLast) {
        return (_jsxs(LinkItemWrapper, Object.assign({ "data-test-id": testId, className: "breadcrumb-item", hasText: !!text, size: size }, { children: [_jsx(Icon, { symbol: isFirst ? "Home" : "chevron_right_flat", color: theme.colors.grey10 }), text && _jsx(DisabledLink, { children: text })] })));
    }
    return (_jsxs(LinkItemWrapper, Object.assign({ "data-preview-id": previewId, "data-test-id": testId, className: "breadcrumb-item", hasText: !!text, size: size }, { children: [!isFirst && (_jsx(Icon, { symbol: "chevron_right_flat", color: theme.colors.grey10 })), _jsx(Link, { windowTarget: windowTarget, stylingType: "flat", icon: isFirst && "Home", target: url, href: url, text: text, onClick: onClick })] })));
};
